import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule]
})
export class CallbackComponent implements OnInit {
  isLoading = true;
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    console.log('Callback component initialized');
  }

  ngOnInit(): void {
    console.log('Callback component initialized');
    this.handleCallback();
  }

  private handleCallback(): void {
    try {
      console.log('Starting callback handling...');
      console.log('Current URL:', window.location.href);
      console.log('Hash:', window.location.hash);
      
      this.authService.handleAuthCallback();
      
      // Check if the token was saved
      const token = this.authService.getToken();
      console.log('Token after callback:', token ? 'Present' : 'Missing');
      
      if (token) {
        this.isLoading = false;
      } else {
        console.error('Token not saved after callback');
        this.errorMessage = 'Authentication failed. Token not saved.';
        this.isLoading = false;
      }
    } catch (error) {
      console.error('Error handling auth callback:', error);
      this.errorMessage = 'Authentication failed. Please try again.';
      this.isLoading = false;
    }
  }

  retryLogin(): void {
    this.router.navigate(['/login']);
  }
} 